import React from 'react';
import { useEffect } from 'react';
import { useRef } from 'react';
import { NavLink, useParams } from 'react-router-dom';

export default function PageNavigation() {
    const params = useParams();
    const menuPath = params['*'].split('/')[0];
    const ref = useRef();

    useEffect(() => {
        const node = ref?.current?.querySelector(
            '.navigation-tabs__link--active',
        );
        ref?.current?.scrollTo({
            left: node?.offsetLeft > 1100 ? node?.offsetLeft : 0,
        });
    }, []);

    const hasScroll = ref?.current?.scrollWidth > ref?.current?.clientWidth;

    return (
        <ul
            ref={ref}
            className="navigation-tabs__list"
            style={{ paddingBottom: hasScroll ? '5px' : 'unset' }}
        >
            <li className="navigation-tabs__list-item">
                <NavLink
                    to={`/clients/${params?.id}/dashboard`}
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation-tabs__link navigation-tabs__link--active'
                            : 'navigation-tabs__link'
                    }
                >
                    Dashboard
                </NavLink>
            </li>
            <li className="navigation-tabs__list-item">
                <NavLink
                    to={`/clients/${params?.id}/details`}
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation-tabs__link navigation-tabs__link--active'
                            : 'navigation-tabs__link'
                    }
                >
                    Details
                </NavLink>
            </li>
            <li className="navigation-tabs__list-item">
                <NavLink
                    to={`/clients/${params?.id}/activated-products`}
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation-tabs__link navigation-tabs__link--active'
                            : 'navigation-tabs__link'
                    }
                >
                    Products
                </NavLink>
            </li>
            <li className="navigation-tabs__list-item">
                <NavLink
                    to={`/clients/${params?.id}/coach-me`}
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation-tabs__link navigation-tabs__link--active'
                            : 'navigation-tabs__link'
                    }
                >
                    CoachMe
                </NavLink>
            </li>
            <li className="navigation-tabs__list-item">
                <NavLink
                    to={`/clients/${params?.id}/terms-of-use`}
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation-tabs__link navigation-tabs__link--active'
                            : 'navigation-tabs__link'
                    }
                >
                    ToU
                </NavLink>
            </li>
            <li className="navigation-tabs__list-item">
                <NavLink
                    to={`/clients/${params?.id}/privacy-policy`}
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation-tabs__link navigation-tabs__link--active'
                            : 'navigation-tabs__link'
                    }
                >
                    Privacy Policy
                </NavLink>
            </li>
            <li className="navigation-tabs__list-item">
                <NavLink
                    to={`/clients/${params?.id}/notifications/email`}
                    className={({ isActive }) =>
                        isActive || menuPath === 'notifications'
                            ? 'navigation-tabs__link navigation-tabs__link--active'
                            : 'navigation-tabs__link'
                    }
                >
                    Notification
                </NavLink>
            </li>
            <li className="navigation-tabs__list-item">
                <NavLink
                    to={`/clients/${params?.id}/communication/general`}
                    className={({ isActive }) =>
                        isActive || menuPath === 'communication'
                            ? 'navigation-tabs__link navigation-tabs__link--active'
                            : 'navigation-tabs__link'
                    }
                >
                    Communication
                </NavLink>
            </li>
            <li className="navigation-tabs__list-item">
                <NavLink
                    to={`/clients/${params?.id}/crm/users`}
                    className={({ isActive }) =>
                        isActive || menuPath === 'crm'
                            ? 'navigation-tabs__link navigation-tabs__link--active'
                            : 'navigation-tabs__link'
                    }
                >
                    CRM
                </NavLink>
            </li>
            <li className="navigation-tabs__list-item">
                <NavLink
                    to={`/clients/${params?.id}/web-app`}
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation-tabs__link navigation-tabs__link--active'
                            : 'navigation-tabs__link'
                    }
                >
                    Web app
                </NavLink>
            </li>
            <li className="navigation-tabs__list-item">
                <NavLink
                    to={`/clients/${params?.id}/insurance`}
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation-tabs__link navigation-tabs__link--active'
                            : 'navigation-tabs__link'
                    }
                >
                    Insurance
                </NavLink>
            </li>
            <li className="navigation-tabs__list-item">
                <NavLink
                    to={`/clients/${params?.id}/sftp`}
                    className={({ isActive }) =>
                        isActive
                            ? 'navigation-tabs__link navigation-tabs__link--active'
                            : 'navigation-tabs__link'
                    }
                >
                    SFTP
                </NavLink>
            </li>
        </ul>
    );
}
